import { render } from "./MarketInquiryFlow.vue?vue&type=template&id=3391d08e&scoped=true&ts=true"
import script from "./MarketInquiryFlow.vue?vue&type=script&lang=ts"
export * from "./MarketInquiryFlow.vue?vue&type=script&lang=ts"

import "./MarketInquiryFlow.vue?vue&type=style&index=0&id=3391d08e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3391d08e"]])

export default __exports__